type MeasurementType = 'минут' | 'часов' | 'мин' | 'час'

export type BillingType = "hour" | "minute"

export interface IBillingConversionResponse {
    fractionalExpression: number
    measurement: MeasurementType
    fullAnswer: string
    replaceWithAnAlternative: number
}

export interface IBillingConversionOptions {
    type: BillingType,
    multipleMeaning?: boolean,
}

export const billingConversion = (timeHour: number, options: IBillingConversionOptions): IBillingConversionResponse => {
    const stringValue =
        options?.multipleMeaning
            ? options?.type === "minute" ? 'минут' : 'часов'
            : options?.type === "minute" ? 'мин' : 'час'

    if (Number.isNaN(timeHour) || (options?.type !== "hour" && options?.type !== "minute")) {
        return {fractionalExpression: timeHour, measurement: stringValue, fullAnswer: String(timeHour), replaceWithAnAlternative: 0}
    }

    if (options?.type === "minute") {
        const fractionalExpression = Math.floor(timeHour / 60 * 100) / 100
        const measurement: MeasurementType = stringValue
        const replaceWithAnAlternative = Math.ceil(parseFloat((timeHour * 60).toFixed(2)))

        const fullAnswer = `${replaceWithAnAlternative} ${measurement}`

        return {
            fractionalExpression,
            measurement,
            replaceWithAnAlternative,
            fullAnswer
        }
    }

    const fractionalExpression = +timeHour
    const measurement: MeasurementType = stringValue
    const replaceWithAnAlternative = fractionalExpression
    const fullAnswer = `${replaceWithAnAlternative} ${measurement}`

    return {
        fractionalExpression,
        measurement,
        replaceWithAnAlternative,
        fullAnswer
    }
}

export const billingConversionRange = (startTime: number, endTime: number, type: BillingType): string | null => {
    if (type !== "hour" && type !== "minute") return null

    const start = billingConversion(startTime, {multipleMeaning: true, type})
    const end = billingConversion(endTime, {multipleMeaning: true, type})

    return `${start?.replaceWithAnAlternative}-${end?.replaceWithAnAlternative} ${end?.measurement}`
}

export const billingConversionPrice = (price: number, type: BillingType): number => {
    if (type === "minute") {
        return parseFloat((price / 60).toFixed(2))
    }

    return price
}